import { signupCookie } from '@/utils/cookies/signupCookie';
import css from './index.module.scss';
import NextImage from '@/components/NextImage';

export default function SignupPopupSuccess({ changeStatu, t, isMobile, locale, Link, optInEmail = true }: any) {
    const EU_SITES: string[] = ['eu', 'de', 'fr', 'it', 'es'];
    const LOCAL_SITES: string[] = ['uk'];
    return (
        <div className={`signup-popup-success ${css['signup-popup-success']} ${isMobile ? 'signup-popup-success-h5' : 'signup-popup-success-pc'}`}>
            <div className="popup-content">
                <NextImage
                    src={require(`@publicLocal/sms-subscribe/${isMobile ? 'h5' : 'pc'}/kv2${
                        EU_SITES?.includes(locale) ? '_eu' : LOCAL_SITES?.includes(locale) ? `_${locale}` : ''
                    }.jpg`)}
                    alt={t('title')}
                    aria-label={t('modal_title')}
                />
                <span className="close" onClick={() => changeStatu(0)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                        <path
                            d="M18 33C26.2843 33 33 26.2843 33 18C33 9.71573 26.2843 3 18 3C9.71573 3 3 9.71573 3 18C3 26.2843 9.71573 33 18 33Z"
                            fill="#054634"
                            fillOpacity="0.3"
                        />
                        <path d="M22.5 13.5L13.5 22.5" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M13.5 13.5L22.5 22.5" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </span>
                <div className="text-wrap">
                    <p className="modal-title">{t(optInEmail ? 'modal_title_email' : 'modal_title_sms')}</p>
                    <p className="modal-desc">{t(optInEmail ? 'modal_desc_email' : 'modal_desc_sms')}</p>
                    <p className="modal-tips">{t('modal_tips')}</p>
                    <Link
                        className="modal-btn"
                        href="/register"
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'select_product',
                            list_name: t('secE_title'),
                            product_name: '',
                            button_name: t('modal_btn'),
                        }}
                        onClick={() => {
                            signupCookie({ entry_name: 'subscription floating' });
                        }}
                    >
                        {t('modal_btn')} &gt;
                    </Link>
                </div>
            </div>
        </div>
    );
}
